import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { Button } from '@components/Button';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { animationTransition } from '@utils/animationTransition';
import { SmallBoldTextStyles } from '@components/typography/interVariants';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${themeSpace(10)};

  ${themeMediaQuery('below_sm')} {
    gap: ${themeSpace(7)};
  }
`;

export const TitleText = styled(Text)`
  text-align: center;
  width: 100%;
  text-align: center;
  max-width: 320px;

  ${themeMediaQuery('sm')} {
    max-width: 500px;
    ${(props) => props.theme.typography.calloutHed32};
  }
`;

export const StyledGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${themeSpace(5)};
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 ${themeSpace(6)};

  ${themeMediaQuery('sm')} {
    grid-template-columns: repeat(4, 1fr);
    gap: ${themeSpace(6)};
  }

  ${themeMediaQuery('md')} {
    gap: ${themeSpace(7)};
  }
`;

export const StyledGridItem = styled.div`
  width: 100%;
  cursor: pointer;
  position: relative;
`;

export const StyledButtonNoneStyled = styled(ButtonNoneStyled)`
  width: 100%;
`;

const ASPECT_RATIO = '280 / 270';

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 100%;
  display: block;
  aspect-ratio: ${ASPECT_RATIO};
  transform: scale(1);
  transition: ${animationTransition('transform')};

  ${StyledButtonNoneStyled}:hover & {
    transform: scale(1.05);
  }
`;

export const HoverButton = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: ${animationTransition('opacity', 'transform')};
  pointer-events: none;

  display: flex;
  align-items: center;
  gap: ${themeSpace(2)};
  padding: ${themeSpace(4)} ${themeSpace(6)};
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid ${(props) => props.theme.colors.mono5};
  backdrop-filter: blur(48px);
  border-radius: 9999px;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.16);

  ${SmallBoldTextStyles};
  font-size: 1rem;

  ${StyledButtonNoneStyled}:hover & {
    transform: translate(-50%, -2rem);
    opacity: 1;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${themeSpace(6)};
`;

export const FooterTitle = styled(Text)`
  text-align: center;

  ${themeMediaQuery('sm')} {
    ${(props) => props.theme.typography.sectionEyeBrow24};
  }
`;

export const OutlinedBlackButton = styled(Button)`
  background-color: transparent;
  color: ${(props) => props.theme.colors.mono1};
  border-color: ${(props) => props.theme.colors.mono1};
  border-width: 2px;
  border-radius: 9999px;

  &:hover {
    background-color: #4d4d4d1a;
    color: ${(props) => props.theme.colors.mono1};
    border-color: ${(props) => props.theme.colors.mono1};
  }

  &:active {
    background-color: #59595933;
    color: ${(props) => props.theme.colors.mono1};
    border-color: ${(props) => props.theme.colors.mono1};
  }
`;
